import { FaImages } from "react-icons/fa"
import NewsFeedImage from "./image"
import { AiTwotoneHeart } from "react-icons/ai"
import speedometer from "./speedometer.png";
import measureIcon from "./measure.png";
import categoryIcon from "./category.png";
import neckIcon from "./neck.png";
import processImage from "./process.png";
import { useEffect, useRef, useState } from "react";
import { IoIosArrowDropdown, IoIosArrowDropup } from "react-icons/io";
import { RiShareBoxFill } from "react-icons/ri";
import Popup from "../../component/Popup";
import TrendImages from "./ImagesPopup";
import HistoryGraph from "./HistoryGraph";
import { useSelector } from "react-redux";
import { Lightbox } from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "yet-another-react-lightbox/plugins/counter.css";
import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import showFloatToPercentage from "../V2Leaderboard/Utils/showFloatToPercentage";
import { SentenceCase } from "../../utility/helper_functions";
import roundtocloses0_5_value from "../V2Leaderboard/Utils/roundToClosest_0_5";
import SilhouetteShare from "./SilhouetteShare/SilhouetteShare";
import NewMeComponent from "../../component/NewMeComponent";
import NewsFeedNewmeTrendPopup from "../NewsfeedNewmeTrend/NewsFeedNewmeTrendPopup";

const NewsFeedTrend = ({ trend, rank, allCollectionNames, addImageToCollection, collectionSets, fetchCollections, retailerAddImageToCollection, retailercollectionSets, trendType, gender, category, forAllTrends, hideTrend, setSearchParams, searchParams, type, setImagePopupData, showNewmeComponent, companyName, retailerKey }) => {
  const [showRetailer, setShowRetailer] = useState(searchParams.get('validated') == 'true' ? true : false)
  const [showNewMeRetailer, setShowNewmeRetailer] = useState(true)
  const styleProcureCounts = useSelector(state => state.styleProcureCounts)
  const [showProductsPopup, setShowProductsPopup] = useState(false)
  const [showHistoryGraph, setShowHistoryGraph] = useState(false)
  const [lightBoxImageIndex, setLightBoxImageIndex] = useState(null)
  const [showNewmeFactoryProducts, setShowNewmeFactoryProducts] = useState(true)
  const [showNewmeLiveProducts, setShowNewmeLiveProducts] = useState(false)
  const [showNewsFeedNewmeTrend, setShowNewsFeedNewmeTrend] = useState(false)
  const [retailerlightBoxImageIndex, setRetailerlightBoxImageIndex] = useState(null)
  const isCompanyNewme = companyName == 'newme'
  const firstLightbox = useRef(false)

  const eventListenerFunc = (e) => {
    setLightBoxImageIndex(null)
    setRetailerlightBoxImageIndex(null)
    window.removeEventListener('popstate', eventListenerFunc)

  }

  useEffect(() => {
    if (lightBoxImageIndex !== null || retailerlightBoxImageIndex !== null) {
      if (!firstLightbox.current) {
        firstLightbox.current = true
        setSearchParams(prev => {
          prev.set('lightbow', 'show')
          return prev
        })
        window.addEventListener('popstate', eventListenerFunc)
      }
    } else {
      firstLightbox.current = false
    }

  }, [lightBoxImageIndex, retailerlightBoxImageIndex])
  const userLoggedIn = useSelector(state => state.userLoggedIn)
  return <div className=' border-b-2 border-b-slate-500 even:bg-slate-100 pt-8'>
    <div className='flex justify-between items-center pt-0.5 lg:pt-2'>
      <div className='flex items-center flex-wrap text-xs lg:text-sm'>
        <div className="font-extralight text-gray-500">
          <a
            className="text-2xl lg:text-[32px] text-blue-700 hover:text-blue-800 active:text-blue-900"
            href={`${window.location.origin}/v2-trend?trends=both&gender=${trend.gender}&category=${encodeURIComponent(trend.category)}&selectedtag=${encodeURIComponent(trend.tag)}&selectedvalue=${encodeURIComponent(trend.value)}`}
            target='_blank'
          ><span className="font-medium ">{rank}.{trend.value}</span>{false ? (SentenceCase(trend.tag)) : null}</a>
          {userLoggedIn && userLoggedIn.curator ?
            <div className="flex mx-2">
              <label>Hide</label>
              <input type={'checkbox'}
                checked={trend.deleted ? false : true}
                className='sr-only peer'
              />
              <div class="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600 dark:peer-checked:bg-blue-600"
                onClick={() => {
                  hideTrend(trend._id, trend.deleted ? false : true)
                }}
              ></div>
              <label>Show</label>
            </div>
            : null}
          <span className='mx-0 text-2xl lg:text-[32px] lg:mx-2' hidden={!forAllTrends}>- Cat: <span className="">{trend.category.slice(0, 1).toUpperCase() + trend.category.slice(1).toLowerCase()}</span></span> </div>
        {trend.totalLikes && trend.totalLikes > 1 && <p className='mx-2 hidden lg:flex items-center'>{trend.totalLikes} <span className=' text-red-600 text-xl'><AiTwotoneHeart /></span></p>}


      </div>
    </div>
    <div className="hidden lg:block">
      {trend.tag != "MULTICOLOR" ? <div className="flex">

        <img src={speedometer} alt="" className="h-4 mr-1" />
        <p><span className="font-semibold text-blue-700">Demand Forecast: </span>For next two months, <span className="font-semibold text-blue-700">{trend.forecastShare && roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) >= 0.5 ? roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) : "less than 0.5"}% of your {trend.category}</span> should be {trend.value} <span className="text-slate-400">({SentenceCase(trend.tag)})</span>.</p>
      </div> : null}
    </div>

    <div className="block lg:hidden text-xs">
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />} >{userLoggedIn && userLoggedIn.curator ? <><span className="text-xs font-semibold flex "><img src={processImage} alt="" className="h-4 mr-1" />Lifecycle :{trend.lifecycle}</span></> : <>Details</>}</AccordionSummary>
        <AccordionDetails>
          {false ? <p className='mx-2  items-center '>{trend.allCount} <span className='text-xl'> <FaImages /></span></p> : null}
          {/*          <p className='mx-2  items-center'><img src={speedometer} alt="" className="h-4 mr-1 inline-block" /> Weekly-Rate-of-Growth:<span className="font-semibold pl-1">{parseInt(trend.rateOfGrowth * 1000) / 10}%{trend.rogState && userLoggedIn && userLoggedIn.curator ? <span className="pl-2">(Is {trend.rogState} Rate of Growth)</span> : null}</span></p>*/}
          {false && <p className='mx-2  items-center' hidden>Avg-Rank: {trend.avgRank}</p>}
          {trend.totalLikes && trend.totalLikes > 1 && <p className='mx-2  items-center'>{trend.totalLikes} <span className=' text-red-600 text-xl'><AiTwotoneHeart /></span></p>}
          <div className='mt-2 mx-2  lg:text-sm flex items-center flex-wrap'>
            {trend.tag != "MULTICOLOR" ? <div className="flex">

              <img src={speedometer} alt="" className="h-4 mr-1" />
              <p><span className="font-semibold text-blue-700">Demand Forecast: </span>For next two months, <span className="font-semibold text-blue-700">{trend.forecastShare && roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) >= 0.5 ? roundtocloses0_5_value(showFloatToPercentage(trend.forecastShare)) : "less than 0.5"}% of your {trend.category}</span> should be {trend.value} <span className="text-slate-400">({SentenceCase(trend.tag)})</span>.</p>
            </div> : null}
            {/*
            <div data-tooltip-id={'depth-tooltip-' + '0' + trend.tag + '-' + trend.value} className='flex w-full shrink-0 lg:w-1/2 lg:shrink'>
              <img src={measure} alt="" className="h-4 mr-1" />
              Weekly-Depth:
              <span className="font-semibold"> {parseInt(trend.depth * 1000) / 10}%</span>
              {userLoggedIn && userLoggedIn.curator ? <span className="italic"> ({trend.DepthState ? <span className="font-semibold"> is {trend.DepthState} depth, </span> : null} In {gender == 'M' ? 'Men' : 'Women'}'s {trend.category}, out of 100% {trend.tag}, {parseInt(trend.depth * 1000) / 10}% were {trend.value}, in the past 7 days. And growing week on week.) <span className="underline" hidden>(See Others)</span></span> : null}
            </div>
            */}
            {userLoggedIn && userLoggedIn.curator ? <div className="flex w-full shrink-0">
              <img src={processImage} alt="" className="h-4 mr-1" />Lifecycle : {trend.lifecycle}</div> : null}
          </div>
          <SilhouetteShare silhouetteShare={trend.silhouetteShare} heading={'Recommended Silhouettes:'} icon={categoryIcon} setImagePopupData={setImagePopupData} trend={trend} />
          {trend.secondaryTagsShare ? trend.secondaryTagsShare.filter(t => t.values.length > 0).map(secondaryTag => <SilhouetteShare silhouetteShare={secondaryTag.values} tag={secondaryTag.tag} icon={secondaryTag.tag == 'NECKLINE' ? neckIcon : (secondaryTag.tag == 'TOP LENGTH' || secondaryTag.tag == 'BOTTOM LENGTH') ? measureIcon : categoryIcon} heading={`Recommended ${secondaryTag.tag}:`} setImagePopupData={setImagePopupData} trend={trend} />) : null}
        </AccordionDetails>

      </Accordion>


    </div>
    <div className="hidden lg:block">

      <div className='mt-2 mx-2 text-xs lg:text-sm flex items-center flex-wrap'>
        {/*
        <p className='mx-2 hidden lg:flex items-center'><img src={speedometer} alt="" className="h-4 mr-1" /> Weekly-Rate-of-Growth:<span className="font-semibold pl-1">{parseInt(trend.rateOfGrowth * 1000) / 10}%{trend.rogState && userLoggedIn && userLoggedIn.curator ? <span className="pl-2">(Is {trend.rogState} Rate of Growth)</span> : null}</span></p>
        <div data-tooltip-id={'depth-tooltip-' + '0' + trend.tag + '-' + trend.value} className='flex w-full shrink-0 lg:w-1/2 lg:shrink'>
          <img src={measure} alt="" className="h-4 mr-1" />
          Weekly-Depth:
          <span className="font-semibold"> {parseInt(trend.depth * 1000) / 10}%</span>
          {userLoggedIn && userLoggedIn.curator ? <span className="italic"> ({trend.DepthState ? <span className="font-semibold"> is {trend.DepthState} depth, </span> : null} In {gender == 'M' ? 'Men' : 'Women'}'s {trend.category}, out of 100% {trend.tag}, {parseInt(trend.depth * 1000) / 10}% were {trend.value}, in the past 7 days. And growing week on week.) <span className="underline" hidden>(See Others)</span></span> : null}
        </div>
      */}
        {userLoggedIn && userLoggedIn.curator ? <div className="flex pl-4 w-full shrink-0 lg:w-1/2 lg:shrink"><img src={processImage} alt="" className="h-4 mr-1" />Lifecycle : {trend.lifecycle}</div> : null}
      </div>

    </div>
    <div className='flex overflow-auto w-[98vw]'>
      {
        trend.images.map((image, index) => <NewsFeedImage image={image} key={index} allCollectionNames={allCollectionNames} addImageToCollection={type == 'retailer' ? retailerAddImageToCollection : addImageToCollection} collectionSets={type == 'retailer' ? retailercollectionSets : collectionSets} fetchCollections={fetchCollections} trendType={type == 'retailer' ? 'retailer' : trendType} setLightBoxImageIndex={setLightBoxImageIndex} index={index} category={trend.category} />)
      }
    </div>
    <div className="hidden lg:block">
      <SilhouetteShare silhouetteShare={trend.silhouetteShare} heading={'Recommended Silhouettes:'} icon={categoryIcon} setImagePopupData={setImagePopupData} trend={trend} />
      {trend.secondaryTagsShare ? trend.secondaryTagsShare.filter(t => t.values.length > 0).map(secondaryTag => <SilhouetteShare silhouetteShare={secondaryTag.values} tag={secondaryTag.tag} icon={secondaryTag.tag == 'NECKLINE' ? neckIcon : (secondaryTag == 'TOP LENGTH' || secondaryTag.tag == 'BOTTOM LENGTH') ? measureIcon : categoryIcon} heading={`Recommended ${secondaryTag.tag}:`} setImagePopupData={setImagePopupData} trend={trend} />) : null}
    </div>
    <div>
      <div className="flex text-[10px] lg:text-sm overflow-x-auto overflow-y-hidden lg:justify-center h-auto py-0.5 items-center mx-1">
        <NewMeComponent showNewme={showNewmeComponent}>
          {trend.recommendedCount && trend.recommendedCount > 0 ? <div >
            {trend.newmeretailerImages && trend.newmeretailerImages.length > 0 ? <button className="flex font-semibold primary-btn  w-full shrink-0 lg:w-auto lg:shrink text-center justify-center" onClick={() => { setShowNewmeRetailer(prev => !prev) }}>{userLoggedIn.company == 'trent' ? 'Westside' : 'Newme'} products ({trend.newmeretailerCount})<span className="mt-1 ml-1">{showNewMeRetailer ? <IoIosArrowDropup strokeWidth={10} /> : <IoIosArrowDropdown strokeWidth={10} />}</span></button> : null}
            <p className="w-full text-center font-semibold">Recommended Count = {trend.recommendedCount}
              {userLoggedIn && userLoggedIn.company == 'Ajio' ? <>, Actual Ajio Products = {trend.companyCount} , Gap = {trend.gapInRecommendation}</> : null}
              <button className="h-full" onClick={() => {
                setShowNewsFeedNewmeTrend(true)
              }}><RiShareBoxFill size={14} className="" /> </button></p>
          </div> : null}
        </NewMeComponent>
        {trend.retailerImages && (trend.productsinlast30days || (userLoggedIn && userLoggedIn.curator)) && trend.retailerImages.length > 0 && type == 'social' && !(['Bags', 'Belt', 'Footwear', 'Caps & Hats', 'Sunglasses', 'Ethinic Wear', 'Coats, Suits, Blazers', 'Sweatshirts & Hoodies', 'Jackets', 'Other Outerwear', 'Sweaters & Cardigans'].includes(trend.category)) ? <button className="flex font-semibold primary-btn  w-full shrink-0 lg:w-auto lg:shrink text-center justify-center" onClick={() => { setShowRetailer(prev => !prev) }}>See retailer products<span className="mt-1 ml-1">{showRetailer ? <IoIosArrowDropup strokeWidth={10} /> : <IoIosArrowDropdown strokeWidth={10} />}</span></button> : null}
        {false && searchParams.get('alltrends') != 'color' ? <a href={`/build-designs?gender=${gender == 'M' ? 'Male' : 'Female'}&category=${encodeURIComponent(trend.category)}&source=&sort=rog&breakdown-level=1&tag=&value=&tag-0=${encodeURIComponent(trend.tag)}&value-0=${encodeURIComponent(trend.value)}`} className="flex font-semibold primary-btn   ml-2 bg-yellow-600 hover:bg-yellow-700 active:bg-yellow-800 text-nowrap" target={'_blank'} >Design {trend.value} {trend.category}</a> : null}
        {userLoggedIn && userLoggedIn.curator ? <button className="flex font-semibold primary-btn  ml-0.5   lg:ml-2 bg-gray-600 hover:bg-gray-700 active:bg-gray-800 w-auto text-nowrap" onClick={() => { setShowHistoryGraph(true) }}>See Graph</button> : null}
      </div>
      <NewMeComponent showNewme={showNewmeComponent}>
        {showNewMeRetailer && isCompanyNewme && trend.newmeretailerImages ? <div className="flex border-t py-1" >
          <button className={`mx-0.5 rounded-full px-2 py-1 text-sm text-white ${showNewmeFactoryProducts ? "bg-blue-500 " : "bg-blue-400"} outline-none`} onClick={() => setShowNewmeFactoryProducts(prev => !prev)}>Newme Factory Products ({trend.newmeretailerImages.filter(im => im.mediaId.includes('newme_factory')).length})</button>
          <button className={`mx-0.5 rounded-full px-2 py-1 text-sm text-white ${showNewmeLiveProducts ? "bg-blue-500 " : "bg-blue-400"} outline-none`} onClick={() => setShowNewmeLiveProducts(prev => !prev)}>Newme Live Products ({trend.newmeretailerImages.filter(im => !im.mediaId.includes('newme_factory')).length})</button>
        </div> : null}
        <div className={`border-t  grid grid-rows-1 ${showNewMeRetailer ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'} transition-all duration-1000`}>
          {showNewMeRetailer ? <div className={`w-full flex overflow-x-auto  border-t-slate-500`} >
            {
              trend.newmeretailerImages ? trend.newmeretailerImages.filter(im => (!isCompanyNewme || (im.mediaId.includes('newme_factory') && showNewmeFactoryProducts) || (!im.mediaId.includes('newme_factory') && showNewmeLiveProducts))).map((image, index) => <NewsFeedImage
                image={image}
                key={index}
                allCollectionNames={allCollectionNames}
                addImageToCollection={retailerAddImageToCollection}
                collectionSets={retailercollectionSets}
                fetchCollections={fetchCollections}
                trendType={'retailer'}
                setLightBoxImageIndex={setRetailerlightBoxImageIndex}
                index={index}
                category={category}
              />) : null
            }
          </div> : null}
        </div>
      </NewMeComponent>
      <div className={`border-t grid grid-rows-1 ${showRetailer ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'} transition-all duration-1000`}>
        {showRetailer ? <div className={`w-full flex overflow-x-auto  border-t-slate-500`} >
          {
            trend.retailerImages.sort((a, b) => {
              return (b.forecastScore && b.forecastScore[category] ? b.forecastScore[category] : 0) - (a.forecastScore && a.forecastScore[category] ? a.forecastScore[category] : 0)
            }).map((image, index) => <NewsFeedImage image={image} key={index} allCollectionNames={allCollectionNames} addImageToCollection={retailerAddImageToCollection} collectionSets={retailercollectionSets} fetchCollections={fetchCollections} trendType={'retailer'} setLightBoxImageIndex={setRetailerlightBoxImageIndex} index={index} category={category} />)
          }
        </div> : null}
      </div>

    </div>
    <Lightbox
      open={lightBoxImageIndex != null}
      close={() => {
        setLightBoxImageIndex(null)
      }}
      index={lightBoxImageIndex}
      slides={trend.images.map(im => ({ src: im.imageUrl }))}
      plugins={[Zoom, Thumbnails, Counter]}
    />
    <Lightbox
      open={retailerlightBoxImageIndex != null}
      close={() => {
        setRetailerlightBoxImageIndex(null)
      }}
      index={retailerlightBoxImageIndex}
      slides={trend.retailerImages.map(im => ({ src: im.imageUrl }))}
      plugins={[Zoom, Thumbnails, Counter]}
    />
    {showProductsPopup ? <Popup isPopUp={showProductsPopup} setIsPopUp={setShowProductsPopup}>
      <TrendImages tag={trend.tag} value={trend.value} category={trend.category} gender={gender} />
    </Popup> : null}
    {showHistoryGraph ? <Popup isPopUp={showHistoryGraph} setIsPopUp={setShowHistoryGraph}>
      <HistoryGraph tag={trend.tag} value={trend.value} category={trend.category} gender={gender} />
    </Popup> : null}
    {showNewsFeedNewmeTrend ? <Popup isPopUp={showNewsFeedNewmeTrend} setIsPopUp={setShowNewsFeedNewmeTrend}>
      <NewsFeedNewmeTrendPopup gender={trend.gender} category={trend.category} tag={trend.tag} value={trend.value} retailer={userLoggedIn.company == 'Ajio' ? 'Ajio' : null} />
    </Popup> : null}
  </div >

}

export default NewsFeedTrend
